import { queryOptions } from '@tanstack/react-query'

import { api, data } from '../client'
import { qk } from '../query-keys'
import { setCsrfToken } from '../session'
import type { AuthConfig, LoginRequest, Me } from '../types'
import { activityHeaders } from './passive'

/** The support caption shown under the sign-in form when /auth/config is unreachable. */
export const DEFAULT_SUPPORT_TEXT = 'Forgot your password? Contact IT support. Access is limited to company staff.'

export function rememberSession(me: Me): Me {
  setCsrfToken(me.csrfToken)
  return me
}

export const meQuery = queryOptions({
  queryKey: qk.me,
  queryFn: async ({ signal, client }) =>
    rememberSession(await data(api.GET('/auth/me', { signal, ...activityHeaders(client, qk.me) }))),
  staleTime: 5 * 60_000,
  retry: false,
  // The route guard turns a 401 here into the sign-in redirect itself.
  meta: { ownsAuthErrors: true },
})

export const authConfigQuery = queryOptions({
  queryKey: qk.authConfig,
  queryFn: async ({ signal }): Promise<AuthConfig> => data(api.GET('/auth/config', { signal })),
  staleTime: Infinity,
  retry: false,
  meta: { ownsAuthErrors: true },
})

export async function login(body: LoginRequest): Promise<Me> {
  return rememberSession(await data(api.POST('/auth/login', { body })))
}

export async function logout(): Promise<void> {
  await api.POST('/auth/logout', { params: { query: {} } })
  setCsrfToken(null)
}
